/* MOS DYMO Finder — "Find the right DYMO labeller" selector.
   Shared by the homepage section and the blog article template.
   Data comes from a JSON file in Shopify Files (data-src); nothing product-specific lives here. */
(function () {
  'use strict';
  if (window.MosDymoFinder) return;

  var ICONS = {
    // Two-tone: outline = currentColor, class "a" = accent fill (apple green on the feature look).
    shelf: '<rect class="a" x="13" y="14" width="5.5" height="4.5" rx=".8"/><path d="M3 4h18M3 12h18M3 20h18M5 4v16M19 4v16"/><rect x="8" y="6.5" width="4.5" height="4" rx=".8"/><rect x="13" y="14" width="5.5" height="4.5" rx=".8"/>',
    home: '<path class="a" d="M10 20v-6h4v6z"/><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10v10h13V10"/><path d="M10 20v-6h4v6"/>',
    parcel: '<rect class="a" x="6" y="13" width="6" height="4" rx=".6"/><path d="M3.5 8.5h17V20h-17z"/><path d="M2.5 5h19v3.5h-19z"/><path d="M10 5v3.5M14 5v3.5"/><rect x="6" y="13" width="6" height="4" rx=".6"/>',
    hardhat: '<path class="a" d="M2.5 16h19v2.5h-19z"/><path d="M4 16a8 8 0 0 1 16 0"/><path d="M2.5 16h19v2.5h-19z"/><path d="M12 8v8M9 9.5v6.5M15 9.5v6.5"/>',
    hand: '<rect class="a" x="15" y="2.5" width="6.5" height="3.5" rx=".8"/><path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12M11 12V4.5a1.5 1.5 0 0 1 3 0V12M14 12V8.5a1.5 1.5 0 0 1 3 0v6"/><path d="M8 13l-1.6-2.2a1.5 1.5 0 0 0-2.6 1.4L6.5 17c1.2 3 3.5 4 6.5 4 3.3 0 5-2.4 5-5.5V14"/>',
    desk: '<rect class="a" x="6.5" y="7.5" width="11" height="4.5" rx=".8"/><rect x="3" y="5" width="18" height="10" rx="1.5"/><path d="M3 18h18M8 15v3M16 15v3"/>',
    tape12: '<rect class="a" x="3" y="9" width="18" height="6" rx="1"/><rect x="3" y="9" width="18" height="6" rx="1"/><path d="M7 12h2M11 12h2M15 12h2"/>',
    tape19: '<rect class="a" x="3" y="7" width="18" height="10" rx="1"/><rect x="3" y="7" width="18" height="10" rx="1"/><path d="M7 10.5h10M7 13.5h6"/>',
    battery: '<rect class="a" x="5" y="10" width="6" height="4" rx=".6"/><rect x="3" y="8" width="15" height="8" rx="1.5"/><path d="M18 10.5h2v3h-2"/>',
    recharge: '<path class="a" d="M11.8 9 8.8 12.6h3l-1.4 2.6 4-3.9h-3z"/><rect x="3" y="8" width="15" height="8" rx="1.5"/><path d="M18 10.5h2v3h-2"/>',
    bluetooth: '<circle class="a" cx="12" cy="12" r="9.5"/><path d="M7.5 8l9 8-4.5 3.8V4.2L16.5 8l-9 8"/>',
    keyboard: '<rect class="a" x="8.5" y="12.5" width="7" height="2" rx=".6"/><rect x="2.5" y="7" width="19" height="10" rx="1.5"/><path d="M6 10h1M9 10h1M12 10h1M15 10h1M18 10h1M6 13.5h1M18 13.5h1"/>',
    phone: '<rect class="a" x="8.5" y="5" width="7" height="10.5" rx=".6"/><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M11 18.5h2"/>',
    'big-label': '<path class="a" d="M3 5a1.5 1.5 0 0 1 1.5-1.5h15A1.5 1.5 0 0 1 21 5v3H3z"/><rect x="3" y="3.5" width="18" height="17" rx="1.5"/><path d="M3 8h18M6.5 11.5h11M6.5 14.5h7M6.5 17.5h9"/>',
    label: '<path class="a" d="M4.5 7.5H8v9H4.5A1.5 1.5 0 0 1 3 15V9a1.5 1.5 0 0 1 1.5-1.5z"/><rect x="3" y="7.5" width="18" height="9" rx="1.5"/><path d="M8 7.5v9M11 11h7M11 13.5h4.5"/>',
    fast: '<path class="a" d="M14 7.5l4.5 4.5-4.5 4.5z"/><path d="M3 12h11M5 8h7M7 16h7"/><path d="M14 7.5l4.5 4.5-4.5 4.5z"/>',
    medium: '<path class="a" d="M12 12V4a8 8 0 0 1 8 8z"/><circle cx="12" cy="12" r="8"/><path d="M12 7.5V12l3 2"/>',
    check: '<circle class="a" cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="8.5"/><path d="M8 12.5l2.5 2.5L16 9.5"/>',
    cross: '<circle cx="12" cy="12" r="8.5"/><path d="M9 9l6 6M15 9l-6 6"/>',
    pc: '<rect class="a" x="5" y="6" width="14" height="8" rx=".6"/><rect x="3" y="4" width="18" height="12" rx="1.5"/><path d="M8 20h8M12 16v4"/>',
    tag: '<circle class="a" cx="8.6" cy="8.6" r="1.9"/><path d="M3.5 4.5v6.3a1.5 1.5 0 0 0 .44 1.06l8.2 8.2a1.5 1.5 0 0 0 2.12 0l5.68-5.68a1.5 1.5 0 0 0 0-2.12l-8.2-8.2A1.5 1.5 0 0 0 10.68 3.5H4.5a1 1 0 0 0-1 1z"/><circle cx="8.6" cy="8.6" r="1.9"/><path d="M12.5 13.5l3-3"/>',
    metal: '<circle class="a" cx="6.5" cy="12" r="1.6"/><rect x="3" y="8" width="18" height="8" rx="1"/><circle cx="6.5" cy="12" r="1.6"/><path d="M10 10.5h8M10 13.5h6"/>'
  };
  function icon(name) {
    var d = ICONS[name] || ICONS.label;
    return '<svg class="mdf-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withComma).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }
  function track(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (e) {}
  }
  var HASH_KEY = 'dymo-finder';
  function readHash() {
    var m = (location.hash || '').match(new RegExp('#' + HASH_KEY + '=([^&]*)'));
    return m ? m[1].split('/').filter(Boolean) : null;
  }
  function writeHash(path, replace) {
    var value = path.length ? '#' + HASH_KEY + '=' + path.join('/') : location.pathname + location.search;
    try { history[replace ? 'replaceState' : 'pushState'](null, '', value); } catch (e) { location.hash = value; }
  }

  function Finder(root) {
    this.root = root;
    this.src = root.getAttribute('data-src');
    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.path = [];
    this.data = null;
    this.cache = {};
    this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.stage = root.querySelector('.mdf-stage');
    this.load();
    var self = this;
    window.addEventListener('hashchange', function () { if (self.data) { self.path = readHash() || []; self.render(true, true); } });
    this.root.addEventListener('click', function (e) { self.onClick(e); });
  }
  Finder.prototype.load = function () {
    var self = this;
    // Hourly cache-bust. Shopify's CDN caches Files for a year and only keys on the `v` query param — anything else is ignored.
    var url = this.src.replace(/[?&]v=[^&]*/, '') ; url += (url.indexOf('?') > -1 ? '&' : '?') + 'v=' + Math.floor(Date.now() / 3600000);
    fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        self.data = d;
        self.root.classList.remove('is-loading');
        self.path = self.validPath(readHash() || []);
        self.render(true, true);
      })
      .catch(function (err) {
        self.root.classList.remove('is-loading');
        self.stage.innerHTML = '<p class="mdf-error">The labeller finder could not load. <a href="/collections/all">Browse all DYMO machines</a> instead.</p>';
        if (window.console) console.warn('MosDymoFinder: data load failed', err);
      });
  };
  Finder.prototype.validPath = function (path) {
    var node = this.data.tree, out = [];
    for (var i = 0; i < path.length; i++) {
      if (!node || !node.options) break;
      var opt = null;
      for (var j = 0; j < node.options.length; j++) if (node.options[j].id === path[i]) opt = node.options[j];
      if (!opt) break;
      out.push(opt.id); node = opt.next;
    }
    return out;
  };
  Finder.prototype.walk = function () {
    var node = this.data.tree, chosen = [];
    for (var i = 0; i < this.path.length; i++) {
      var opt = null;
      for (var j = 0; j < node.options.length; j++) if (node.options[j].id === this.path[i]) opt = node.options[j];
      chosen.push(opt); node = opt.next;
    }
    return { node: node, chosen: chosen };
  };
  Finder.prototype.depth = function () {
    // longest remaining chain from a node, for the "Step x of y" label
    function longest(n) { if (!n || !n.options) return 0; var m = 0; n.options.forEach(function (o) { m = Math.max(m, longest(o.next)); }); return 1 + m; }
    var w = this.walk();
    return { step: this.path.length + 1, total: this.path.length + longest(w.node) };
  };

  Finder.prototype.onClick = function (e) {
    var t = e.target.closest('[data-mdf]'); if (!t) return;
    var action = t.getAttribute('data-mdf');
    if (action === 'pick') { e.preventDefault(); t.classList.add('is-picked'); t.setAttribute('aria-checked', 'true'); this.choose(t.getAttribute('data-id')); }
    else if (action === 'back') { e.preventDefault(); this.go(this.path.slice(0, -1)); }
    else if (action === 'restart') { e.preventDefault(); this.go([]); }
    else if (action === 'jump') { e.preventDefault(); this.go(this.path.slice(0, parseInt(t.getAttribute('data-to'), 10))); }
    else if (action === 'atc') { e.preventDefault(); this.addToCart(t); }
    else if (action === 'persona') { e.preventDefault(); this.persona(t.getAttribute('data-id')); }
  };
  Finder.prototype.choose = function (id) {
    var w = this.walk(), opt = null;
    w.node.options.forEach(function (o) { if (o.id === id) opt = o; });
    if (!opt) return;
    var next = this.path.concat([id]);
    track('dymo_finder_step', { step: this.path.length + 1, question: w.node.q, answer: opt.label, path: next.join('/') });
    this.go(next);
  };
  Finder.prototype.go = function (path) {
    this.path = path; writeHash(path); this.render(false, false);
  };

  Finder.prototype.render = function (replace, quiet) {
    var w = this.walk();
    var html;
    if (w.node.result) html = this.renderResult(w); else html = this.renderQuestion(w);
    var self = this;
    var dd = this.depth();
    this.root.style.setProperty('--mdf-pct', (w.node.result ? 100 : Math.max(8, Math.round((dd.step - 1) / dd.total * 100))) + '%');
    this.root.classList.toggle('is-result', !!w.node.result);
    this.swap(html, quiet, function () {
      if (w.node.result) self.hydrate(w.node.result);
      var focus = self.stage.querySelector('[data-mdf-focus]');
      if (focus && !quiet) { focus.focus({ preventScroll: false }); }
    });
  };
  Finder.prototype.swap = function (html, quiet, done) {
    var stage = this.stage;
    if (this.reduceMotion || quiet) { stage.innerHTML = html; done(); return; }
    stage.classList.add('is-leaving');
    setTimeout(function () { stage.innerHTML = html; stage.classList.remove('is-leaving'); stage.classList.add('is-entering'); requestAnimationFrame(function () { requestAnimationFrame(function () { stage.classList.remove('is-entering'); }); }); done(); }, 160);
  };
  Finder.prototype.crumbs = function (w) {
    if (!w.chosen.length) return '';
    var self = this;
    return '<ol class="mdf-crumbs" aria-label="Your answers">' + w.chosen.map(function (o, i) {
      return '<li><button type="button" class="mdf-crumb" data-mdf="jump" data-to="' + i + '" title="Change this answer">' + esc(o.why || o.label) + '</button></li>';
    }).join('') + '</ol>';
  };
  Finder.prototype.renderQuestion = function (w) {
    var d = this.depth(), n = w.node, self = this;
    var opts = n.options.map(function (o, i) {
      return '<li class="mdf-opt" style="--i:' + i + '"><button type="button" class="mdf-card" role="radio" aria-checked="false" data-mdf="pick" data-id="' + esc(o.id) + '"' + (i === 0 ? ' data-mdf-focus' : '') + '>' +
        (o.img ? '<span class="mdf-card__ico mdf-card__ico--img"><img src="' + esc(o.img) + '" alt="" width="52" height="52" loading="lazy"></span>' : '<span class="mdf-card__ico">' + icon(o.icon) + '</span>') +
        '<span class="mdf-card__label">' + esc(o.label) + '</span>' +
        (o.sub ? '<span class="mdf-card__sub">' + esc(o.sub) + '</span>' : '') +
        '<span class="mdf-card__arrow" aria-hidden="true">→</span></button></li>';
    }).join('');
    return '<div class="mdf-step">' +
      '<div class="mdf-meta"><span class="mdf-progress" aria-live="polite">Step ' + d.step + ' of ' + d.total + '</span>' + this.crumbs(w) + '</div>' +
      '<h3 class="mdf-q" id="mdf-q-' + this.path.length + '">' + esc(n.q) + '</h3>' +
      (n.help ? '<p class="mdf-help">' + esc(n.help) + '</p>' : '') +
      '<ul class="mdf-opts mdf-opts--' + n.options.length + '" role="radiogroup" aria-labelledby="mdf-q-' + this.path.length + '">' + opts + '</ul>' +
      (!this.path.length && this.data.personas && this.data.personas.items && this.data.personas.items.length ? this.renderPersonas() : '') +
      (!this.path.length && this.data.compare && this.data.compare.url ? '<div class="mdf-nav mdf-nav--compare"><a class="mdf-link" href="' + esc(this.data.compare.url) + '">' + esc(this.data.compare.label || 'Compare all machines') + ' →</a></div>' : '') +
      (this.path.length ? '<div class="mdf-nav"><button type="button" class="mdf-link" data-mdf="back">← Back one step</button><button type="button" class="mdf-link" data-mdf="restart">Start again</button></div>' : '') +
      '</div>';
  };
  Finder.prototype.renderPersonas = function () {
    var ps = this.data.personas;
    return '<div class="mdf-personas"><span class="mdf-personas__label">' + esc(ps.label || 'Or start from your job') + '</span><div class="mdf-personas__row">' +
      ps.items.map(function (p) { return '<button type="button" class="mdf-chip" data-mdf="persona" data-id="' + esc(p.id) + '">' + esc(p.label) + '</button>'; }).join('') +
      '</div></div>';
  };
  Finder.prototype.persona = function (id) {
    var items = (this.data.personas && this.data.personas.items) || [], p = null;
    items.forEach(function (x) { if (x.id === id) p = x; });
    if (!p) return;
    var path = this.validPath(p.path || []);
    track('dymo_finder_persona', { persona: p.label, path: path.join('/') });
    this.go(path);
  };
  Finder.prototype.renderResult = function (w) {
    var p = this.data.products[w.node.result];
    if (!p) return '<p class="mdf-error">We could not find that machine. <button type="button" class="mdf-link" data-mdf="restart">Start again</button></p>';
    var why = w.chosen.map(function (o) { return o.why || o.label; });
    var note = this.data.price_note ? ' <span class="mdf-price__note">' + esc(this.data.price_note) + '</span>' : '';
    return '<div class="mdf-result" data-model="' + esc(w.node.result) + '">' +
      '<div class="mdf-meta"><span class="mdf-progress mdf-progress--done">Your match</span>' + this.crumbs(w) + '</div>' +
      '<div class="mdf-result__grid">' +
        '<a class="mdf-result__media" href="/products/' + esc(p.handle) + '" tabindex="-1" aria-hidden="true"><img class="mdf-result__img" src="' + esc(p.snapshot_image || '') + '" alt="" width="480" height="480" loading="eager"></a>' +
        '<div class="mdf-result__body">' +
          '<p class="mdf-kicker">We recommend the</p>' +
          '<h3 class="mdf-result__name" data-mdf-focus tabindex="-1">DYMO ' + esc(p.name) + '</h3>' +
          '<p class="mdf-why"><strong>Why:</strong> ' + esc(why.join(' · ')) + '.</p>' +
          '<p class="mdf-blurb">' + esc(p.blurb) + '</p>' +
          '<p class="mdf-price"><span class="mdf-price__amount" data-mdf-price>' + money(Math.round(parseFloat(p.snapshot_price) * 100), this.moneyFormat) + '</span>' + note + ' <span class="mdf-stock" data-mdf-stock></span></p>' +
          '<div class="mdf-soh" data-mdf-soh hidden></div>' +
          '<div class="mdf-actions">' +
            '<button type="button" class="mdf-btn mdf-btn--primary" data-mdf="atc" data-variant="' + p.variant_id + '" data-name="' + esc(p.name) + '">Add to cart</button>' +
            '<a class="mdf-btn mdf-btn--secondary" href="/products/' + esc(p.handle) + '">View product</a>' +
          '</div>' +
          '<p class="mdf-atc-msg" role="status" aria-live="polite" data-mdf-msg></p>' +
          '<ul class="mdf-links">' +
            (p.labels ? '<li><a href="' + esc(p.labels.url) + '">' + esc(p.labels.label) + ' →</a></li>' : '') +
            (p.bundle ? '<li><a href="/products/' + esc(p.bundle.handle) + '">Also available as a kit: ' + esc(p.bundle.title.replace(/^Dymo\s+/i, '')) + ' →</a></li>' : '') +
            (this.data.catalogue_url ? '<li><a href="' + esc(this.data.catalogue_url) + '" target="_blank" rel="noopener">See the full DYMO range (PDF catalogue) →</a></li>' : '') +
          '</ul>' +
        '</div>' +
      '</div>' +
      '<div class="mdf-nav"><button type="button" class="mdf-link" data-mdf="back">← Back one step</button><button type="button" class="mdf-link" data-mdf="restart">Start again</button></div>' +
      '</div>';
  };
  // Stock on hand — mirrors the product page "Stock On Hand" panel (same feed, same tiers, same headline rule) so the two never disagree.
  var TIERS = [
    { max: 0, color: '#9F0C0C', lit: 0, ang: 172, label: 'Restocking' },
    { max: 10, color: '#CE5F13', lit: 1, ang: 140, label: 'Last Few' },
    { max: 50, color: '#FAB219', lit: 3, ang: 90, label: 'Low Stock' },
    { max: 1 / 0, color: '#319F0C', lit: 5, ang: 8, label: 'In Stock' }
  ];
  var SEGMENTS = ['M12.0 60.3 A50 50 0 0 1 20.2 32.6 L36.9 43.6 A30 30 0 0 0 32.0 60.2 Z', 'M21.8 30.3 A50 50 0 0 1 44.9 13.0 L51.7 31.8 A30 30 0 0 0 37.9 42.2 Z', 'M47.5 12.1 A50 50 0 0 1 76.5 12.1 L70.7 31.3 A30 30 0 0 0 53.3 31.3 Z', 'M79.1 13.0 A50 50 0 0 1 102.2 30.3 L86.1 42.2 A30 30 0 0 0 72.3 31.8 Z', 'M103.8 32.6 A50 50 0 0 1 112.0 60.3 L92.0 60.2 A30 30 0 0 0 87.1 43.6 Z'];
  function tierFor(q) { for (var i = 0; i < TIERS.length; i++) if (q <= TIERS[i].max) return TIERS[i]; return TIERS[TIERS.length - 1]; }
  function gaugeSvg(t) {
    var paths = '';
    for (var i = 0; i < 5; i++) paths += '<path d="' + SEGMENTS[i] + '" fill="' + (i < t.lit ? t.color : '#C6C6C6') + '"/>';
    var a = t.ang * Math.PI / 180, x = (62 + 43 * Math.cos(a)).toFixed(1), y = (60 - 43 * Math.sin(a)).toFixed(1);
    return '<svg class="mdf-soh__g" viewBox="0 0 124 74" aria-hidden="true" focusable="false">' + paths + '<line x1="62" y1="60" x2="' + x + '" y2="' + y + '" stroke="' + t.color + '" stroke-width="5" stroke-linecap="round"/><circle cx="62" cy="60" r="8.5" fill="' + t.color + '"/></svg>';
  }
  var sohPromise = null;
  Finder.prototype.loadSoh = function () {
    var cfg = this.data.stock; if (!cfg || !cfg.origin) return Promise.reject(new Error('no stock config'));
    if (sohPromise) return sohPromise;
    sohPromise = fetch(cfg.origin + cfg.stamp + '?v=' + Date.now(), { credentials: 'omit', cache: 'no-store' }).then(function (r) { return r.json(); }).catch(function () { return {}; })
      .then(function (st) { return fetch(cfg.origin + cfg.soh + (st && st.v ? '?v=' + encodeURIComponent(st.v) : ''), { credentials: 'omit' }); })
      .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.json(); })
      .then(function (j) { return { map: (j && j.s) || {}, built: (j && j.built) || '' }; });
    sohPromise.catch(function () { sohPromise = null; });
    return sohPromise;
  };
  Finder.prototype.renderSoh = function (model) {
    var p = this.data.products[model], cfg = this.data.stock, self = this;
    if (!p || !p.barcode || !cfg) return;
    this.loadSoh().then(function (feed) {
      var host = self.stage.querySelector('[data-mdf-soh]'); if (!host || !self.stage.querySelector('[data-model="' + model + '"]')) return;
      var b = String(p.barcode), keys = [b, b.replace(/^0+/, ''), '0' + b, '00' + b], row = null;
      for (var i = 0; i < keys.length && !row; i++) if (feed.map[keys[i]]) row = feed.map[keys[i]];
      if (!row) return; // not fed to us: say nothing rather than guess
      var states = cfg.states || ['QLD', 'NSW', 'VIC', 'WA', 'SA'], have = [], missing = [], best = null, cells = '';
      states.forEach(function (st, i) {
        var n = row[i] || 0, t = tierFor(n);
        if (n > 0) { have.push(st); if (!best || TIERS.indexOf(t) > TIERS.indexOf(best)) best = t; } else missing.push(st);
        cells += '<div class="mdf-soh__cell" title="' + esc(st + ': ' + t.label) + '"><span class="mdf-soh__st">' + st + '</span>' + gaugeSvg(t) + '<span class="mdf-soh__lb" style="color:' + t.color + '">' + t.label + '</span></div>';
      });
      var cutoff = cfg.cutoff || '11am', head, note;
      if (have.length) {
        head = best.label + (have.length <= 2 ? ' \u2014 ships from ' + have.join(' and ') : '');
        note = missing.length === 0 ? 'In stock in every state. Order before ' + cutoff + ' for same-day dispatch.' : 'Ships to ' + missing.join(', ').replace(/, ([A-Z]+)$/, ' and $1') + ' from the nearest state that has it. Order before ' + cutoff + ' for same-day dispatch.';
      } else { best = TIERS[0]; head = 'Restocking'; note = 'None on hand right now \u2014 we can still order this in. <a href="/pages/contact">Get in touch</a> and we\'ll confirm lead time.'; }
      host.innerHTML = '<div class="mdf-soh__head"><span class="mdf-soh__title">Stock on hand</span>' + (feed.built ? '<span class="mdf-soh__upd">Updated ' + esc(feed.built) + '</span>' : '') + '</div>' +
        '<p class="mdf-soh__sum"><i style="background:' + best.color + '"></i>' + esc(head) + '</p>' +
        '<div class="mdf-soh__row">' + cells + '</div><p class="mdf-soh__note">' + note + '</p>';
      host.hidden = false;
    }).catch(function () {});
  };
  // Live price, image and availability from the storefront so the JSON snapshot never goes stale on screen.
  Finder.prototype.hydrate = function (model) {
    var p = this.data.products[model], self = this;
    track('dymo_finder_result', { model: model, product: p.name, handle: p.handle, path: this.path.join('/') });
    this.renderSoh(model);
    var apply = function (prod) {
      var v = null;
      (prod.variants || []).forEach(function (x) { if (String(x.id) === String(p.variant_id)) v = x; });
      v = v || prod.variants[0];
      var priceEl = self.stage.querySelector('[data-mdf-price]'); if (priceEl && v) priceEl.textContent = money(v.price, self.moneyFormat);
      var img = self.stage.querySelector('.mdf-result__img'); if (img && prod.featured_image) img.src = prod.featured_image;
      var stock = self.stage.querySelector('[data-mdf-stock]');
      var atc = self.stage.querySelector('[data-mdf="atc"]');
      if (v && !v.available) { if (stock) stock.textContent = 'Currently unavailable'; if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } }
      if (v && atc) atc.setAttribute('data-variant', v.id);
    };
    if (this.cache[p.handle]) return apply(this.cache[p.handle]);
    fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (prod) { self.cache[p.handle] = prod; if (self.stage.querySelector('[data-model="' + model + '"]')) apply(prod); })
      .catch(function () {});
  };
  Finder.prototype.addToCart = function (btn) {
    var id = btn.getAttribute('data-variant'), msg = this.stage.querySelector('[data-mdf-msg]'), self = this;
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
    // Same path the theme's own product form takes: ask Shopify to return the cart drawer + header bubble sections, then hand them to the drawer.
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = location.pathname;
      try { if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn); } catch (e) {}
    }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        btn.textContent = 'Added ✓';
        if (msg) msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
        track('dymo_finder_add_to_cart', { variant_id: id, product: btn.getAttribute('data-name') });
        var rendered = false;
        if (cart && res && res.sections && typeof cart.renderContents === 'function') { try { cart.renderContents(res); rendered = true; } catch (e) {} }
        if (!rendered) self.refreshCartBubble();
        try { document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { variant: { id: id }, quantity: 1, sectionId: 'dymo-finder' } })); } catch (e) {}
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: c, sectionId: 'dymo-finder' } })); }).catch(function () {});
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        if (msg) msg.innerHTML = esc((err && (err.description || err.message)) || 'Could not add to cart.') + ' <a href="/products/' + esc(self.data.products[self.stage.querySelector('.mdf-result').getAttribute('data-model')].handle) + '">Open the product page</a>';
      });
  };

  Finder.prototype.refreshCartBubble = function () {
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sec) {
      var html = sec && sec['cart-icon-bubble']; var host = document.getElementById('cart-icon-bubble'); if (!html || !host) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html; var inner = tmp.querySelector('.shopify-section') || tmp;
      host.innerHTML = inner.innerHTML;
    }).catch(function () {});
  };
  function mount(root) {
    if (root.__mdf) return;
    // A blog post can carry an empty <div data-dymo-finder></div>; the widget moves itself there so it sits inside the article body.
    var slot = document.querySelector('[data-dymo-finder]:not(.mdf)');
    if (slot && !slot.contains(root)) { slot.appendChild(root.closest('.mdf-wrap') || root); slot.classList.add('mdf-slotted'); }
    root.__mdf = new Finder(root);
  }
  window.MosDymoFinder = { mount: mount, Finder: Finder };
  function init() { Array.prototype.forEach.call(document.querySelectorAll('.mdf[data-src]'), mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
